// src/styles/generateCssVariables.ts

export const generateCssVariables = (colors: Record<string, any>, prefix = "--"): string => {
    const generateVars = (obj: Record<string, any>, parentKey = ""): string => {
        return Object.entries(obj)
            .map(([key, value]) => {
                const variableName = `${parentKey}-${key}`;
                return typeof value === "object"
                    ? generateVars(value, variableName)
                    : `${prefix}${variableName}: ${value};`;
            })
            .join("\n");
    };

    return generateVars(colors);
};
